var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconTeacher(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.73421 14.7678C9.46644 15.5 10.645 15.5 13.002 15.5H16.9994C19.3564 15.5 20.5349 15.5 21.2672 14.7678C21.9994 14.0355 21.9994 12.857 21.9994 10.5V8.5C21.9994 6.14298 21.9994 4.96447 21.2672 4.23223C20.5349 3.5 19.3564 3.5 16.9994 3.5H12.9994C10.6424 3.5 9.46385 3.5 8.73162 4.23223C8.11121 4.85264 8.01906 5.79344 8.00459 7.5C7.99611 8.49992 8.00198 9.50006 8.00198 10.5C8.00198 12.857 8.00198 14.0355 8.73421 14.7678Z",
    fill: "black",
    fillOpacity: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 15.5C8.88071 15.5 10 14.3807 10 13C10 11.6193 8.88071 10.5 7.5 10.5C6.11929 10.5 5 11.6193 5 13C5 14.3807 6.11929 15.5 7.5 15.5Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13 15.5C10.7083 21.5 4.29167 15.5 2 21.5",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 15.5H17.0013C19.3583 15.5 20.5368 15.5 21.2691 14.7678C22.0013 14.0355 22.0013 12.857 22.0013 10.5V8.5C22.0013 6.14298 22.0013 4.96447 21.2691 4.23223C20.5368 3.5 19.3583 3.5 17.0013 3.5H13.0013C10.6443 3.5 9.46576 3.5 8.73353 4.23223C8.11312 4.85264 8.01838 5.79344 8.00391 7.5",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 15.5C8.88071 15.5 10 14.3807 10 13C10 11.6193 8.88071 10.5 7.5 10.5C6.11929 10.5 5 11.6193 5 13C5 14.3807 6.11929 15.5 7.5 15.5Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12 7.5H18M18 11.5H15",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTeacher);
export default __webpack_public_path__ + "static/media/icon-teacher.edb0b1a3360b7fc61a73c42317481386.svg";
export { ForwardRef as ReactComponent };